import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromFile from './file.reducer';
import * as FileSelectors from './file.selectors';
import * as FileActions from './file.actions';
import { IFile } from '@care-portals/api-interfaces';
import { FileEntity } from './file.models';

@Injectable()
export class FileFacade {
  loading$ = this.store.pipe(select(FileSelectors.getFilesLoading));
  allFile$ = this.store.pipe(select(FileSelectors.getAllFile));
  files$ = this.store.pipe(select(FileSelectors.getFileEntities));
  recentFiles$ = this.store.pipe(select(FileSelectors.getRecentFiles));
  archivedFiles$ = this.store.pipe(select(FileSelectors.getArchivedFiles));
  uniqueFileTags$ = this.store.pipe(select(FileSelectors.getUniqueFileTags));
  uniqueFileFolders$ = this.store.pipe(select(FileSelectors.getUniqueFileFolders));

  constructor(private store: Store<fromFile.FilePartialState>) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadFiles(customerId: string, folder?: string) {
    this.dispatch(FileActions.loadFiles({ customerId, folder }));
  }

  getFile(customerId: string, fileName: string, folder?: string) {
    this.dispatch(FileActions.getFile({ customerId, fileName, folder }));
  }

  uploadFile(
    customerId: string,
    file: IFile,
    folder?: string,
    onSuccess?: (file: FileEntity) => void
  ) {
    this.dispatch(
      FileActions.uploadFile({ customerId, file, folder, onSuccess })
    );
  }

  deleteFile(
    customerId: string,
    fileName: string,
    folder?: string,
    onSuccess?: () => void,
    onFailure?: () => void
  ) {
    this.dispatch(
      FileActions.deleteFile({
        customerId,
        fileName,
        folder,
        onSuccess,
        onFailure
      })
    );
  }
}
